var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloud(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 60,
    height: 38.446,
    viewBox: "0 0 60 38.446",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4",
    "data-name": "Trac\\xE9 4",
    d: "M55.3,21.026A12.027,12.027,0,0,0,43.383,8.492a12.2,12.2,0,0,0-8.674,3.646A13.925,13.925,0,0,0,8.486,21.124a11.162,11.162,0,0,0,4.682,21.3H50.832a11.162,11.162,0,0,0,4.466-21.4Z",
    transform: "translate(-2 -3.975)",
    fill: "#365644"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloud);
export default __webpack_public_path__ + "static/media/Cloud.34364ee897b1501bce629c2b70168f87.svg";
export { ForwardRef as ReactComponent };